import axios from 'axios'

const apiClient = axios.create({
  baseURL: global.vesteda.apiUrl,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
})

export default {
  getGeo(placeId) {
    return apiClient.get(`/getgeo?placeId=${placeId}`)
  },
  getUnits(filter) {
    return apiClient.post('/search/facet', filter)
  },
  getAutoCompleteOptions(query) {
    return apiClient.get(
      `/autocompleteplace?lang=${global.vesteda.culture}&query=${query}`
    )
  },
}
